module.exports = __webpack_public_path__ + "img/cycle.4816f7d1.svg";